import { computed, onMounted, onUnmounted, ref } from 'vue';

export const useScreenSize = () => {
  const width = ref(0),
    height = ref(0);

  const handleScreenResize = () => {
    width.value = window.innerWidth;
    height.value = window.innerHeight;
  };

  const isMobile = computed(() => {
    return width.value <= 720;
  });

  onMounted(() => {
    handleScreenResize();
    window.addEventListener('resize', handleScreenResize);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', handleScreenResize);
  });

  return { handleScreenResize, width, height, isMobile };
};
